import type { CountryParamsType } from '~/app/types/countryParamsType';
import { DeliveryMoment } from '~/app/types/deliveryMoment';

export interface CountryParams {
  fr: CountryParamsType;
  es: CountryParamsType;
  pt: CountryParamsType;
  it: CountryParamsType;
  dk: CountryParamsType;
}

export type CountryCode = keyof CountryParams;

export const countryParams: CountryParams = {
  fr: {
    ABSENT: true,
    ABSENT_REASON: ['DANOREP', 'DADATEULT', 'DAREFUS', 'DANOINFO'],
    ACCEPT_ORDERS: false,
    BETA_TESTERS_FLORISTS: [
      '0014935',
      '0023980',
      '0022587',
      '0003567',
      '0030703',
      '0013684',
      '0028952',
      '0027371',
      '0004358',
      '0030465',
      '0029922',
      '0022930',
      '0026945',
      '0026426',
      '0013649',
      '0028476',
      '0026935',
      '0004204',
      '0028026',
    ],
    CANCEL_ORDERS: true,
    CATALOG_LOCAL_URL:
      'https://catalogue-fleuriste.interflora.fr/?utm_medium=MonMagasin&utm_source=Bouton&utm_campaign=France',
    CATALOG_ABROAD_URL: 'https://catalogue-fleuriste.interflora.fr/liste-pays',
    CONTACT_OPTIONS: [
      'CANCEL',
      'INFO',
      'HELP',
      'SUPPLY',
      'QUALITY',
      'SHOP1',
      'SHOP2',
      'CALL',
      'INDEMNITY',
      'CLAIM',
      'B2B',
    ],
    CONTACT_URL: 'https://faq-florist.interflora.fr/hc/fr/requests/new',
    DARK_STORES: ['0000990'],
    DELIVERY_TIME_SLOTS: {
      [DeliveryMoment.Morning]: [8, 13],
      [DeliveryMoment.Afternoon]: [13, 20],
      [DeliveryMoment.Evening]: [17, 20],
      [DeliveryMoment.Wholeday]: [8, 20],
    },
    DELIVERY_TO_GRAVE: true,
    DELIVERY_TO_GRAVE_CODE: '02',
    DISPLAY_BONUS: false,
    DISPLAY_COMMUNICATION: true,
    DISPLAY_CUSTOMER_CARE_OPENING_INFO: false,
    DISPLAY_DISCLAIMER: false,
    DISPLAY_MULTI_DELIVERED: true,
    DISPLAY_MULTI_DOWNLOAD_AS_CSV: true,
    DISPLAY_MULTI_MARK_AS_PRINT: true,
    DISPLAY_MULTI_PRINT: true,
    DISPLAY_MULTI_UNMARK_AS_PRINT: true,
    DISPLAY_NEW_COLLECTION: true,
    DOCUMENT_TYPE: {
      invoiceVendor: '',
      invoicePurchase: '',
      invoiceBalance: '',
      orderSender: '',
      orderReceiver: 'FR_DOC_ORDER_RECEIVER',
      orderCart: '',
      invoiceExtract: '',
      invoiceExecutionsRectify: '',
      invoiceQuotas: '',
      invoiceExecutions: '',
      invoiceCommissions: '',
      invoiceCommissionsRectify: '',
      invoiceMaterial: '',
      invoiceQuotasRectify: '',
      invoiceSCISales: '',
      saft: '',
    },
    EXTERNAL_DELIVERY: true,
    FAQ_URL: 'https://faq-florist.interflora.fr/hc/fr',
    GOOGLE_PLACE_COUNTRY: ['FR', 'GP', 'MQ', 'GF', 'RE', 'YT', 'PM', 'BL', 'MF', 'WF', 'PF', 'NC', 'TF', 'CP'],
    INTERNAL_DELIVERY: true,
    IS_DELIVERY_ALLOWED: true,
    IS_FREE_MESSAGE_CARD: true,
    IS_FREE_PRICE_AVAILABLE: true,
    LEGAL_DOCUMENTS: [
      {
        name: 'Contrat Interflora applicable au 1er octobre 2025',
        url: 'Contrat_INTERFLORA_en_vigueur_au_1er_octobre_2025.pdf',
      },
      {
        name: 'Annexe 1 au contrat INTERFLORA',
        url: 'ANNEXE_1_AU_CONTRAT_INTERFRLORA_RGPD.pdf',
      },
      {
        name: 'Règles en vigueur applicables au 11 avril 2025',
        url: 'ITF-11.04.2025-Regles_en_vigueur.pdf',
      },
      {
        name: 'Règles en vigueur applicables au 01 septembre 2026',
        url: 'ITF-01.09.2026-Regles_en_vigueur.pdf',
      },
      {
        name: `Charte d’Engagement entre Interflora et ses fleuristes – Mai 2024`,
        url: 'Charte-Engagement-Interflora-Avril-2024_BD.pdf',
      },
    ],
    MESSAGE_CARD_CODE: '',
    MORNING_HOUR_LIMIT: 13,
    NEED_ACCESSORY_FOR_FUNERAL_TR: true,
    NEED_ADDRESS_COMPLEMENT: true,
    NEED_CAPPING: true,
    NEED_COMPENSATIONS: true,
    NEED_DECEASED_NAME: true,
    NEED_EXCLUSIONS: true,
    NEED_GOOGLE_PLACE: true,
    NEED_KPI: true,
    NEED_MASSIVE_DAYS_UPDATE: false,
    NEED_MESSAGE_SIGNATURE: true,
    NEED_MULTI_PRINT: true,
    NEED_PHOTOS: true,
    NEED_PSP: false,
    NEED_REMAINING_TIME: false,
    NEED_STOCK_MANAGEMENT: true,
    NEED_SUPPLIES_MANAGEMENT: true,
    NEED_VALIDATION_CODE: true,
    NEED_WEEKLY_CALENDAR: true,
    ORDER_ON_MAP: true,
    ONBOARDING_GUIDES: true,
    PSM_CODE: ['PSM-R', 'PSM-N'],
    POSSIBLE_TO_CANCEL_DELIVERY: true,
    REASSIGN_ORDERS: true,
    REASSIGN_REASON: ['PCO', 'PFO', 'PL', 'LL', 'RT', 'PAM'],
    RECIPIENT_SMS_ENABLED: true,
    REFUSE_ORDERS: false,
    REFUSE_REASON: [],
    // RUB
    RIBBON_CODE: ['RUB', 'RUB20'],
    ZENDESK_URL: 'https://static.zdassets.com/ekr/snippet.js?key=53d0baca-0d5d-429c-b520-3969668d91a9',
    PARTNER_WEBSITE: [],
  },

  es: {
    ABSENT: true,
    ABSENT_REASON: ['DANOREP', 'DADATEULT', 'DAREFUS', 'DANOINFO'],
    ACCEPT_ORDERS: true,
    BETA_TESTERS_FLORISTS: [],
    CANCEL_ORDERS: false,
    CATALOG_LOCAL_URL: 'https://florist-catalog.prod.interflora.es/',
    CATALOG_ABROAD_URL: 'https://florist-catalog.prod.interflora.es/internacional',
    CONTACT_OPTIONS: ['ORDERINCIDENT', 'ORDERMATERIAL', 'INVOICEINCIDENT', 'SUGGESTION'],
    CONTACT_URL: 'https://itfspainflorist.zendesk.com/hc/es/requests/new',
    DARK_STORES: ['008339'],
    DELIVERY_TIME_SLOTS: {
      [DeliveryMoment.Morning]: [10, 15],
      [DeliveryMoment.Afternoon]: [17, 21],
      [DeliveryMoment.Evening]: [18, 21],
      [DeliveryMoment.Wholeday]: [10, 21],
    },
    DELIVERY_TO_GRAVE: false,
    DELIVERY_TO_GRAVE_CODE: '',
    DISPLAY_BONUS: false,
    DISPLAY_COMMUNICATION: true,
    DISPLAY_CUSTOMER_CARE_OPENING_INFO: false,
    DISPLAY_DISCLAIMER: false,
    DISPLAY_MULTI_DELIVERED: true,
    DISPLAY_MULTI_DOWNLOAD_AS_CSV: true,
    DISPLAY_MULTI_MARK_AS_PRINT: true,
    DISPLAY_MULTI_PRINT: true,
    DISPLAY_MULTI_UNMARK_AS_PRINT: true,
    DISPLAY_NEW_COLLECTION: false,
    DOCUMENT_TYPE: {
      invoiceVendor: 'IT_INVOICE_VENDOR',
      invoicePurchase: 'IT_INVOICE_PURCHASE',
      invoiceBalance: 'IT_INVOICE_BALANCE',
      orderSender: 'IT_DOC_ORDER_SENDER',
      orderReceiver: 'IT_DOC_ORDER_RECEIVER',
      orderCart: 'IT_DOC_ORDER_CART',
      invoiceExtract: 'SP_INVOICE_EXTRACT',
      invoiceExecutionsRectify: 'SP_INVOICE_EXECUTIONS_RECTIFY',
      invoiceQuotas: 'SP_INVOICE_QUOTAS',
      invoiceExecutions: 'SP_INVOICE_EXECUTIONS',
      invoiceCommissions: 'SP_INVOICE_COMMISSIONS',
      invoiceCommissionsRectify: 'SP_INVOICE_COMMISSIONS_RECTIFY',
      invoiceMaterial: 'SP_INVOICE_MATERIAL',
      invoiceQuotasRectify: 'SP_INVOICE_QUOTAS_RECTIFY',
      invoiceSCISales: 'SP_INVOICE_CSI_SALES',
      saft: 'PT_SAFT',
    },
    EXTERNAL_DELIVERY: true,
    FAQ_URL: '',
    GOOGLE_PLACE_COUNTRY: ['ES'],
    INTERNAL_DELIVERY: true,
    IS_DELIVERY_ALLOWED: true,
    IS_FREE_MESSAGE_CARD: true,
    IS_FREE_PRICE_AVAILABLE: false,
    LEGAL_DOCUMENTS: [],
    MESSAGE_CARD_CODE: 'T0100',
    MORNING_HOUR_LIMIT: 13,
    NEED_ACCESSORY_FOR_FUNERAL_TR: false,
    NEED_ADDRESS_COMPLEMENT: false,
    NEED_CAPPING: false,
    NEED_DECEASED_NAME: true,
    NEED_EXCLUSIONS: false,
    NEED_GOOGLE_PLACE: false,
    NEED_KPI: false,
    NEED_MASSIVE_DAYS_UPDATE: true,
    NEED_MESSAGE_SIGNATURE: false,
    NEED_MULTI_PRINT: true,
    NEED_PHOTOS: false,
    NEED_PSP: false,
    NEED_REMAINING_TIME: true,
    NEED_STOCK_MANAGEMENT: false,
    NEED_SUPPLIES_MANAGEMENT: false,
    NEED_VALIDATION_CODE: false,
    NEED_WEEKLY_CALENDAR: false,
    ORDER_ON_MAP: false,
    ONBOARDING_GUIDES: false,
    PSM_CODE: ['ACF'],
    POSSIBLE_TO_CANCEL_DELIVERY: false,
    REASSIGN_ORDERS: false,
    REASSIGN_REASON: [],
    RECIPIENT_SMS_ENABLED: false,
    REFUSE_ORDERS: true,
    REFUSE_REASON: [
      { key: '3', reason: 'No tiene material' },
      { key: '10', reason: 'Rechaza por distancia' },
      { key: '12', reason: 'Faltan datos' },
    ],
    RIBBON_CODE: ['AC001S'],
    ZENDESK_URL: 'https://static.zdassets.com/ekr/snippet.js?key=8f635a39-7deb-469f-97cf-372a256a4edc',
    NEED_COMPENSATIONS: false,
    PARTNER_WEBSITE: [],
  },

  pt: {
    ABSENT: true,
    ABSENT_REASON: ['DANOREP', 'DADATEULT', 'DAREFUS', 'DANOINFO'],
    ACCEPT_ORDERS: true,
    BETA_TESTERS_FLORISTS: [],
    CANCEL_ORDERS: false,
    CATALOG_LOCAL_URL: '',
    CATALOG_ABROAD_URL: '',
    CONTACT_OPTIONS: ['ORDERINCIDENT', 'ORDERMATERIAL', 'INVOICEINCIDENT', 'SUGGESTION'],
    CONTACT_URL: '',
    DARK_STORES: [],
    DELIVERY_TIME_SLOTS: {
      [DeliveryMoment.Morning]: [10, 15],
      [DeliveryMoment.Afternoon]: [17, 21],
      [DeliveryMoment.Wholeday]: [10, 21],
    },
    DELIVERY_TO_GRAVE: false,
    DELIVERY_TO_GRAVE_CODE: '',
    DISPLAY_BONUS: false,
    DISPLAY_COMMUNICATION: false,
    DISPLAY_CUSTOMER_CARE_OPENING_INFO: false,
    DISPLAY_DISCLAIMER: false,
    DISPLAY_MULTI_DELIVERED: true,
    DISPLAY_MULTI_DOWNLOAD_AS_CSV: true,
    DISPLAY_MULTI_MARK_AS_PRINT: true,
    DISPLAY_MULTI_PRINT: true,
    DISPLAY_MULTI_UNMARK_AS_PRINT: true,
    DISPLAY_NEW_COLLECTION: false,
    DOCUMENT_TYPE: {
      invoiceVendor: 'IT_INVOICE_VENDOR',
      invoicePurchase: 'IT_INVOICE_PURCHASE',
      invoiceBalance: 'IT_INVOICE_BALANCE',
      orderSender: 'IT_DOC_ORDER_SENDER',
      orderReceiver: 'IT_DOC_ORDER_RECEIVER',
      orderCart: 'IT_DOC_ORDER_CART',
      invoiceExtract: 'SP_INVOICE_EXTRACT',
      invoiceExecutionsRectify: 'SP_INVOICE_EXECUTIONS_RECTIFY',
      invoiceQuotas: 'SP_INVOICE_QUOTAS',
      invoiceExecutions: 'SP_INVOICE_EXECUTIONS',
      invoiceCommissions: 'SP_INVOICE_COMMISSIONS',
      invoiceCommissionsRectify: 'SP_INVOICE_COMMISSIONS_RECTIFY',
      invoiceMaterial: 'SP_INVOICE_MATERIAL',
      invoiceQuotasRectify: 'SP_INVOICE_QUOTAS_RECTIFY',
      invoiceSCISales: 'SP_INVOICE_CSI_SALES',
      saft: 'PT_SAFT',
    },
    EXTERNAL_DELIVERY: true,
    FAQ_URL: '',
    GOOGLE_PLACE_COUNTRY: ['PT'],
    INTERNAL_DELIVERY: true,
    IS_DELIVERY_ALLOWED: true,
    IS_FREE_MESSAGE_CARD: true,
    IS_FREE_PRICE_AVAILABLE: false,
    LEGAL_DOCUMENTS: [],
    MESSAGE_CARD_CODE: 'T0100',
    MORNING_HOUR_LIMIT: 13,
    NEED_ADDRESS_COMPLEMENT: false,
    NEED_CAPPING: false,
    NEED_DECEASED_NAME: true,
    NEED_EXCLUSIONS: false,
    NEED_GOOGLE_PLACE: false,
    NEED_KPI: false,
    NEED_MASSIVE_DAYS_UPDATE: false,
    NEED_MESSAGE_SIGNATURE: false,
    NEED_MULTI_PRINT: true,
    NEED_PHOTOS: false,
    NEED_PSP: false,
    NEED_REMAINING_TIME: true,
    NEED_STOCK_MANAGEMENT: false,
    NEED_SUPPLIES_MANAGEMENT: false,
    NEED_VALIDATION_CODE: false,
    NEED_WEEKLY_CALENDAR: false,
    ORDER_ON_MAP: false,
    ONBOARDING_GUIDES: false,
    NEED_ACCESSORY_FOR_FUNERAL_TR: false,
    PSM_CODE: ['ACF'],
    POSSIBLE_TO_CANCEL_DELIVERY: false,
    REASSIGN_ORDERS: false,
    REASSIGN_REASON: [],
    RECIPIENT_SMS_ENABLED: false,
    REFUSE_ORDERS: true,
    REFUSE_REASON: [
      { key: '3', reason: 'Sem material' },
      { key: '10', reason: 'Recusar devido à distância' },
      { key: '12', reason: 'Dados em falta' },
    ],
    RIBBON_CODE: ['CO0025'],
    ZENDESK_URL: '',
    NEED_COMPENSATIONS: false,
    PARTNER_WEBSITE: [],
  },

  it: {
    ABSENT: true,
    ABSENT_REASON: ['DANOREP', 'DADATEULT', 'DAREFUS', 'DANOINFO'],
    ACCEPT_ORDERS: true,
    BETA_TESTERS_FLORISTS: [],
    CANCEL_ORDERS: false,
    CATALOG_LOCAL_URL: 'https://florist-catalog.prod.interflora.it/',
    CATALOG_ABROAD_URL: 'https://florist-catalog.prod.interflora.it/lista-paesi',
    CONTACT_OPTIONS: ['ORDER', 'PARTNER', 'ADMIN'],
    CONTACT_URL: 'https://itfitalyflorist.zendesk.com/hc/it/requests/new',
    DARK_STORES: ['85030', '85011', '85101', '85000'],
    DELIVERY_TIME_SLOTS: {
      [DeliveryMoment.Morning]: [9, 14],
      [DeliveryMoment.Afternoon]: [15, 20],
      [DeliveryMoment.Wholeday]: [9, 21],
    },
    DELIVERY_TO_GRAVE_CODE: '',
    DELIVERY_TO_GRAVE: false,
    DISPLAY_BONUS: false,
    DISPLAY_COMMUNICATION: true,
    DISPLAY_CUSTOMER_CARE_OPENING_INFO: true,
    DISPLAY_DISCLAIMER: false,
    DISPLAY_MULTI_DELIVERED: true,
    DISPLAY_MULTI_DOWNLOAD_AS_CSV: true,
    DISPLAY_MULTI_MARK_AS_PRINT: true,
    DISPLAY_MULTI_PRINT: true,
    DISPLAY_MULTI_UNMARK_AS_PRINT: true,
    DISPLAY_NEW_COLLECTION: false,
    DOCUMENT_TYPE: {
      invoiceVendor: 'IT_INVOICE_VENDOR',
      invoicePurchase: 'IT_INVOICE_PURCHASE',
      invoiceBalance: 'IT_INVOICE_BALANCE',
      orderSender: 'IT_DOC_ORDER_SENDER',
      orderReceiver: 'IT_DOC_ORDER_RECEIVER',
      orderCart: 'IT_DOC_ORDER_CART',
      invoiceExtract: 'SP_INVOICE_EXTRACT',
      invoiceExecutionsRectify: 'SP_INVOICE_EXECUTIONS_RECTIFY',
      invoiceQuotas: 'SP_INVOICE_QUOTAS',
      invoiceExecutions: 'SP_INVOICE_EXECUTIONS',
      invoiceCommissions: 'SP_INVOICE_COMMISSIONS',
      invoiceCommissionsRectify: 'SP_INVOICE_COMMISSIONS_RECTIFY',
      invoiceMaterial: 'SP_INVOICE_MATERIAL',
      invoiceQuotasRectify: 'SP_INVOICE_QUOTAS_RECTIFY',
      invoiceSCISales: 'SP_INVOICE_CSI_SALES',
      saft: 'PT_SAFT',
    },
    EXTERNAL_DELIVERY: true,
    FAQ_URL: 'https://itfitalyflorist.zendesk.com/hc/it',
    GOOGLE_PLACE_COUNTRY: ['IT', 'SM'],
    INTERNAL_DELIVERY: true,
    IS_DELIVERY_ALLOWED: true,
    IS_FREE_MESSAGE_CARD: true,
    IS_FREE_PRICE_AVAILABLE: true,
    LEGAL_DOCUMENTS: [
      {
        name: 'Condizioni Economiche',
        url: '20241213_ALL.-C-Condizioni-Economiche-Copia-per-il-Fiorista_1_.pdf',
      },
      {
        name: 'Fiori&Regali',
        url: '20251403_Allegato_F_Fiori&Regali.pdf',
      },
      {
        name: 'Contratto Interflora Affiliazione',
        url: '18.12.2023-Contratto_Interflora_Affiliazione.pdf',
      },
      {
        name: 'Regolamento Interflora',
        url: '20241213_ALL.-B-Regolamento-Interflora_pdf.pdf',
      },
    ],
    MESSAGE_CARD_CODE: 'AM001',
    MORNING_HOUR_LIMIT: 14,
    NEED_ACCESSORY_FOR_FUNERAL_TR: false,
    NEED_ADDRESS_COMPLEMENT: false,
    NEED_CAPPING: false,
    NEED_DECEASED_NAME: false,
    NEED_EXCLUSIONS: false,
    NEED_GOOGLE_PLACE: false,
    NEED_KPI: true,
    NEED_MASSIVE_DAYS_UPDATE: true,
    NEED_MESSAGE_SIGNATURE: false,
    NEED_MULTI_PRINT: true,
    NEED_PHOTOS: true,
    NEED_PSP: true,
    NEED_REMAINING_TIME: true,
    NEED_STOCK_MANAGEMENT: false,
    NEED_SUPPLIES_MANAGEMENT: false,
    NEED_VALIDATION_CODE: false,
    NEED_WEEKLY_CALENDAR: false,
    ORDER_ON_MAP: true,
    ONBOARDING_GUIDES: false,
    PSM_CODE: ['ACF', 'BSCF', 'SP', 'HTB', '0000'],
    POSSIBLE_TO_CANCEL_DELIVERY: false,
    REASSIGN_ORDERS: false,
    REASSIGN_REASON: [],
    RECIPIENT_SMS_ENABLED: false,
    REFUSE_ORDERS: true,
    REFUSE_REASON: [
      { key: '3', reason: 'Non ho questo prodotto' },
      { key: '10', reason: 'Rifiuto a causa della distanza' },
      { key: '12', reason: 'Dati mancanti' },
    ],
    RIBBON_CODE: ['AC001'],
    ZENDESK_URL: 'https://static.zdassets.com/ekr/snippet.js?key=c9846c16-16f9-46fd-8063-0caf3f52b631',
    NEED_COMPENSATIONS: false,
    PARTNER_WEBSITE: [],
  },

  dk: {
    ABSENT: false,
    ABSENT_REASON: [],
    ACCEPT_ORDERS: false,
    BETA_TESTERS_FLORISTS: [],
    CANCEL_ORDERS: false,
    CATALOG_ABROAD_URL: '',
    CATALOG_LOCAL_URL: '',
    CONTACT_OPTIONS: ['CANCEL', 'INFO'],
    CONTACT_URL: '',
    DARK_STORES: [],
    DELIVERY_TIME_SLOTS: {
      [DeliveryMoment.Morning]: [9, 14],
      [DeliveryMoment.Afternoon]: [15, 20],
      [DeliveryMoment.Wholeday]: [9, 19],
    },
    DELIVERY_TO_GRAVE_CODE: '',
    DELIVERY_TO_GRAVE: false,
    DISPLAY_BONUS: false,
    DISPLAY_COMMUNICATION: false,
    DISPLAY_CUSTOMER_CARE_OPENING_INFO: false,
    DISPLAY_DISCLAIMER: false,
    DISPLAY_MULTI_DELIVERED: false,
    DISPLAY_MULTI_DOWNLOAD_AS_CSV: false,
    DISPLAY_MULTI_MARK_AS_PRINT: true,
    DISPLAY_MULTI_PRINT: false,
    DISPLAY_MULTI_UNMARK_AS_PRINT: true,
    DISPLAY_NEW_COLLECTION: false,
    DOCUMENT_TYPE: {
      invoiceVendor: '',
      invoicePurchase: '',
      invoiceBalance: '',
      orderSender: '',
      orderReceiver: '',
      orderCart: '',
      invoiceExtract: '',
      invoiceExecutionsRectify: '',
      invoiceQuotas: '',
      invoiceExecutions: '',
      invoiceCommissions: '',
      invoiceCommissionsRectify: '',
      invoiceMaterial: '',
      invoiceQuotasRectify: '',
      invoiceSCISales: '',
      saft: '',
    },
    EXTERNAL_DELIVERY: true,
    FAQ_URL: '',
    GOOGLE_PLACE_COUNTRY: ['DK'],
    INTERNAL_DELIVERY: false,
    IS_DELIVERY_ALLOWED: false,
    IS_FREE_MESSAGE_CARD: true,
    IS_FREE_PRICE_AVAILABLE: false,
    LEGAL_DOCUMENTS: [],
    MESSAGE_CARD_CODE: '',
    MORNING_HOUR_LIMIT: 13,
    NEED_ACCESSORY_FOR_FUNERAL_TR: false,
    NEED_ADDRESS_COMPLEMENT: false,
    NEED_CAPPING: false,
    NEED_DECEASED_NAME: true,
    NEED_EXCLUSIONS: false,
    NEED_GOOGLE_PLACE: false,
    NEED_KPI: false,
    NEED_MASSIVE_DAYS_UPDATE: false,
    NEED_MESSAGE_SIGNATURE: true,
    NEED_MULTI_PRINT: false,
    NEED_PHOTOS: false,
    NEED_PSP: false,
    NEED_REMAINING_TIME: false,
    NEED_STOCK_MANAGEMENT: true,
    NEED_SUPPLIES_MANAGEMENT: false,
    NEED_VALIDATION_CODE: false,
    NEED_WEEKLY_CALENDAR: false,
    ORDER_ON_MAP: false,
    ONBOARDING_GUIDES: false,
    PSM_CODE: [],
    POSSIBLE_TO_CANCEL_DELIVERY: false,
    REASSIGN_ORDERS: false,
    REASSIGN_REASON: [],
    RECIPIENT_SMS_ENABLED: false,
    REFUSE_ORDERS: false,
    REFUSE_REASON: [],
    RIBBON_CODE: [],
    NEED_COMPENSATIONS: false,
    PARTNER_WEBSITE: [],
    ZENDESK_URL: '',
  },
};
